import type { CSSProperties } from "react";
import { useEffect, useMemo } from "react";
import { useSelector } from "src/redux/hooks";

import { TextInput } from "../TextInput/TextInput";

interface YachtDataInputProps {
  id: string;
  value: string;
  yachtProp?: string;
  placeholder?: string;
  readonly?: boolean;
  outline?: string;
  textStyle?: CSSProperties;
  onChange: (value: string) => void;
}

export function YachtDataInput({
  id,
  value,
  yachtProp,
  placeholder,
  readonly,
  outline,
  textStyle,
  onChange,
}: YachtDataInputProps) {
  const yachtData = useSelector(state => state.generatorSlice.yachtData);

  const yachDataValue = useMemo(() => {
    if (!yachtProp || !yachtData) return "";

    const parts = yachtProp.split(".");
    let current: any = yachtData;
    for (const p of parts) {
      if (current == null) return "";
      current = current[p];
    }
    return current ? String(current) : "";
  }, [yachtData, yachtProp]);

  const effectiveValue = yachDataValue || value;

  useEffect(() => {
    if (!value && yachDataValue) {
      onChange(yachDataValue);
    }
  }, [value, yachDataValue, onChange]);

  return (
    <TextInput
      id={id}
      value={effectiveValue}
      placeholder={placeholder}
      readonly={readonly}
      outline={outline}
      textStyle={textStyle}
      onChange={onChange}
    />
  );
}
